import { sheetMaterialLines } from './simulationStudy.js';
import { colorVariantFields, snapshotMaterialColors } from './materialColors.js';

export function presetRows(sheet) {
  return sheet?.color_preset?.variants || [];
}

// Called only when adding an article. Saved documents supply their own details,
// even when their color list is deliberately empty.
export function initialColorDetails(sheet, existingDetails = null) {
  if (existingDetails) return existingDetails;
  const rows = presetRows(sheet);
  return {
    simulated_colors: rows.map((row) => row.color),
    color_variants: Object.fromEntries(rows.map((row) => [row.color, structuredClone(colorVariantFields(row))])),
  };
}

export function serializeColorPreset(sheet, colors, variants) {
  return colors.map((color) => {
    const assignments = variants[color]?.material_colors || {};
    const material_colors = snapshotMaterialColors(sheet, assignments);
    // Hiding a column never erases or deactivates its existing assignments.
    for (const line of sheetMaterialLines(sheet || {})) {
      if (line.color_variant_excluded && assignments[line.id]) material_colors[line.id] = assignments[line.id];
    }
    return { color, ...colorVariantFields({ color, ...variants[color] }), material_colors };
  });
}

export function copyPrincipalColors(colors, variants, material, colorSettings = {}) {
  const next = { ...variants };
  for (const color of colors) {
    const base = variants[color]?.garment_color || color;
    next[color] = { ...variants[color], garment_color: base,
      material_colors: { ...variants[color]?.material_colors,
        [material.id]: { ...variants[color]?.material_colors?.[material.id],
          color: colorSettings[base]?.description || base,
          usage: material.color_usage || '', name: material.material?.internal_description || '',
          reference: material.material_supplier?.supplier_ref || material.material?.code || '',
        },
      },
    };
  }
  return next;
}

export function mergeLoadedColorDetails(current, preview, loaded) {
  const untouchedColors = current.simulated_colors === preview.simulated_colors && current.color_variants === preview.color_variants;
  return { ...loaded, ...current, ...(untouchedColors ? {
    simulated_colors: loaded.simulated_colors, color_variants: loaded.color_variants,
  } : {}) };
}

// Defaults affect only the article's preset editor; other screens retain their rules.
export function colorPresetEditorSheet(sheet, excludedIds = []) {
  const processes = sheet?.process_lines || [];
  const material_lines = sheetMaterialLines(sheet || {}).map(line => {
    const parent = processes.find(p => p.id === line.process_line_id || p.material_lines?.some(m => m.id === line.id));
    const excluded = line.color_variant_excluded === true || excludedIds.includes(line.id);
    return { ...line, color_variant_excluded: excluded,
      requires_color: line.requires_color === true || (!excluded && parent?.process?.allows_color_variants === true) };
  });
  return { ...sheet, material_lines, orphan_material_lines: [], process_lines: [] };
}
